import { cloneElement, ReactElement, FC, PropsWithChildren } from 'react';

import { WithTimelineSectionProps } from './interfaces';

const WithTimelineSection: FC<PropsWithChildren<WithTimelineSectionProps>> = ({
  children,
  allowedTypes,
  exludedTypes,
  section,
  ...rest
}) => {
  const sctionType = section.type;

  if (
    (!allowedTypes?.includes(sctionType) && !exludedTypes) ||
    exludedTypes?.includes(sctionType)
  ) {
    return null;
  }

  return !!children ? cloneElement(children as ReactElement, rest) : null;
};

export default WithTimelineSection;
